"use strict";const r=require("./index-df4084de.js"),s=require("./index-8b6fbbdb.js");function u(t,i){s.requiredArgs(2,arguments);var a=r.toDate(t),n=r.toDate(i),e=a.getTime()-n.getTime();return e<0?-1:e>0?1:e}exports.compareAsc=u;
